import React, { useState, useEffect } from 'react'

const DigitalClockComponent = (props) => {

  const {stylesForText} = props;

  const [hours, setHours] = useState('')
  const [minutes, setMinutes] = useState('')
  const [amPm, setAmPm] = useState('')
  const [showColon, setShowColon] = useState(true)

  useEffect(() => {
    const updateClock = () => {
      const now = new Date()
      const hoursValue = now.getHours()
      const minutesValue = now.getMinutes()
      const formattedHours = hoursValue % 12 || 12 // Convert to 12-hour format
      const formattedAmPm = hoursValue >= 12 ? 'PM' : 'AM'
      const formattedMinutes = minutesValue.toString().padStart(2, '0')
      setHours(formattedHours.toString())
      setMinutes(formattedMinutes)
      setAmPm(formattedAmPm)
    }

    updateClock() // Initial update
    const interval = setInterval(updateClock, 1000) // Update every second

    return () => clearInterval(interval) // Cleanup on unmount
  }, [])

  useEffect(() => {
    // Toggle colon visibility every 500ms for blinking effect
    const colonInterval = setInterval(() => {
      setShowColon(prev => !prev)
    }, 500)

    return () => clearInterval(colonInterval)
  }, [])

  return (
    <div style={{ ...stylesForText, display: 'inline-flex', alignItems: 'center' }}>
      <span>{hours}</span>
      <span style={{ opacity: showColon ? 1 : 0, transition: 'opacity 0.1s ease' }}>:</span>
      <span>{minutes}</span>
      <span style={{ marginLeft: '8px' }}>{amPm}</span>
    </div>
  )
}

export default DigitalClockComponent
